import React from "react";
import { t } from "i18next";
import AiccBreadCrumb from "components/common/AiccBreadCrumb";
import { ContentCard } from "components/ContentCard";
import { getPathPrefix } from "utils/coreUtils";

function ContactAicc() {
  return (
    <>
      <AiccBreadCrumb
        homeLink={getPathPrefix("dashboard")}
        title={t("contactPage.breadCrumb.title")}
        items={t("contactPage.breadCrumb.items", {
          returnObjects: true,
        })}
      />
      <div className="col-12 col-lg-9 col-md-12 mx-auto">
        <ContentCard
          iconName="fa-square-phone"
          title={t("contactPage.cardTitle")}
          bodyContent={
            <div className="contact-wrapper">
              <ul className="contact-info">
                <li>
                  <i className="fa-solid  fa-envelope me-2 text-primary"></i>
                  <a
                    href={`mailto:${t(
                      "contactPage.aiccContactInfo.emailAddress"
                    )}`}
                  >
                    {t("contactPage.aiccContactInfo.emailAddress")}
                  </a>
                </li>
                <li>
                  <i className="fa-solid fa-phone me-2 text-primary"></i>
                  <a
                    href={`mailto:${t(
                      "contactPage.aiccContactInfo.phoneNumber"
                    )}`}
                  >
                    {t("contactPage.aiccContactInfo.phoneNumber")}
                  </a>
                </li>
                <li>
                  <i className="fa-solid fa-location-dot me-2 text-primary"></i>
                  <a href="#">{t("contactPage.aiccContactInfo.location")}</a>
                </li>
              </ul>
            </div>
          }
        />
      </div>
    </>
  );
}

export default ContactAicc;
